import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Background, Container, Contents, Title, Navi } from '../Common/Common.style';
import { Hr, Wrapper, CareMenu, HomeCare, OtherItems, Items, SubTitle } from './ConfirmPage.style';
import Modal from '../../../../components/Modal/RecieverFragments';
import { saveCustomerProfile } from '../../../../services/api';
import Placeholder from '../../../../components/Placeholder';
import Image from '../../../../components/ContentfulImage';
import { sublimicDiagnosisFormatedData } from '../../../../utils';
import updateDiagnosisResult from '../../../../redux/actions/diagnosisResult';
import CareMenuImage from '../CareMenuImage/CareMenuImage';
import { CATEGORY_HAIRCARE, CATEGORY_SCALPCARE, CATEGORY_HAIR_SCALP_CARE } from '../CareMenuImage/CareMenuImageConst';

class ConfirmPage extends React.Component {
  state = {
    finishModal: {
      isOpen: false,
      loadingFinish: false,
      loadingTreatment: false,
    },
  };

  handleOpenModal = () => {
    this.setState({
      finishModal: { isOpen: true },
    });
    // if (this.props.handleOpenModal) this.props.handleOpenModal();
  };

  handleCloseModal = () => {
    this.setState({
      finishModal: { isOpen: false },
    });
    // if (this.props.handleCloseModal) this.props.handleCloseModal();
  };

  /**
   * 「診断結果を保存せずに終了する」ボタン押下時に呼ばれる
   */
  saveAndFinish = () => {
    this.handlerSave(false);
  };

  /**
   * 「登録して診断結果を保存する」ボタン押下時に呼ばれる
   */
  saveAndTreatment = () => {
    this.handlerSave(true);

    // PINコードを Storage から削除する
    localStorage.removeItem('storePinCode');
  };

  handlerSave = redirect => {
    // eslint-disable-next-line react/prop-types
    const { history, locale, sublimicDiagnosis, sublimicDiagnosisResults, customerProfile } = this.props;
    if (customerProfile && customerProfile.firstName && customerProfile.email) {
      const data = Object.assign({}, sublimicDiagnosisFormatedData(sublimicDiagnosis, sublimicDiagnosisResults));
      data.firstName = customerProfile.firstName;
      data.lastName = '';
      data.email = customerProfile.email;
      data.locale = locale;
      this.setState({
        loadingFinish: !redirect,
        loadingTreatment: redirect,
      });
      saveCustomerProfile(data).then(res => {
        if (res.success && res.id) {
          this.setState(
            {
              loadingFinish: false,
              loadingTreatment: false,
            },
            () => {
              // eslint-disable-next-line no-unused-expressions
              redirect && this.props.updateDiagnosisResult({ redirectToCustomerTop: true });
              history.push(`/${locale}/salon-consultation/customer/top`);
            }
          );
        } else {
          this.setState({
            loadingFinish: false,
            loadingTreatment: false,
          });
        }
      });
    } else {
      this.setState(
        {
          loadingFinish: false,
          loadingTreatment: false,
        },
        () => {
          // eslint-disable-next-line no-unused-expressions
          redirect && this.props.updateDiagnosisResult({ redirectToCustomerTop: true });
          if (redirect) {
            history.push(`/${locale}/salon-consultation/customer/regist`);
          } else {
            history.push(`/${locale}/salon-consultation/sublimic/home`);
          }
        }
      );
    }
  };

  renderCareMenu = (selectedCare, category) => {
    const { copy } = this.props;
    return (
      <div className="care-menu__box">
        <div className="care-menu__box-left">
          <div className="care-menu__image">
            <CareMenuImage category={category} />
          </div>
        </div>
        <div className="care-menu__box-right">
          <h1 className="care-menu__heading">
            {(selectedCare.title && this.renderTitle(selectedCare.title)) || <Placeholder w="300px" h="45px" />}
          </h1>
          <p className="care-menu__paragraph">
            <span>
              {(selectedCare.salonSetting && `${selectedCare.salonSetting.displayName} : `) || (
                <Placeholder w="143px" h="19px" />
              )}
            </span>
            <span>
              {selectedCare.salonSetting &&
                selectedCare.salonSetting.operationTime &&
                `${selectedCare.salonSetting.operationTime || 0} ${copy.common.minute || ''} `}
              {selectedCare.salonSetting &&
                selectedCare.salonSetting.price && (
                  <React.Fragment>{this.renderPrice(selectedCare.salonSetting.price)}</React.Fragment>
                )}
            </span>
          </p>
          <div className="care-menu__box2">
            <div className="care-menu__image">
              <CareMenuImage category={category} />
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderTitle = title => {
    const tits = title.split('、');
    return tits.map((e, i) => (i === tits.length - 1 ? <div key={i}>{e}</div> : <div key={i}>{`${e}、`}</div>));
  };

  renderPrice = price => {
    const { locale, authSalonSettingData } = this.props;
    if (
      price &&
      authSalonSettingData &&
      authSalonSettingData.basicSettings &&
      authSalonSettingData.basicSettings.currencyCode
    ) {
      const localeName = locale.split('_')[0];
      const currencyName = authSalonSettingData.basicSettings.currencyCode;
      return new Intl.NumberFormat(localeName, { style: 'currency', currency: currencyName }).format(price);
    }
    return null;
  };

  renderHomeCareItem = selectedHomeCareItems => {
    const { homeCareCategory } = this.props;
    //
    let flg = false;
    return selectedHomeCareItems.map((careItem, index) => {
      if (careItem.type && careItem.type.indexOf('Wonder Shield') >= 0) return null;
      if (flg && careItem.type && careItem.type.indexOf('Shampoo') >= 0) return null;
      if (careItem.type && careItem.type.indexOf('Shampoo') >= 0) flg = true;
      return (
        <dl className="items__list-dl" key={index}>
          <dt>{homeCareCategory[careItem.type.replace(' ', '').replace('-', '')] || ''}</dt>
          <dd>
            <div className="items__image">
              {careItem && careItem.product && careItem.product.variants && careItem.product.variants[0].image ? (
                <Image src={careItem.product.variants[0].image} options={{ w: '130px', h: '130px' }} />
              ) : (
                <Placeholder w="130px" h="130px" />
              )}
            </div>
            <p className="items__paragraph">{careItem.product.name}</p>
          </dd>
        </dl>
      );
    });
  };

  renderWonderShield = selectedHomeCareItems => {
    const { homeCareCategory } = this.props;
    return selectedHomeCareItems.map((careItem, index) => {
      if (careItem.type && careItem.type.indexOf('Wonder Shield') >= 0) {
        return (
          <div className="other-items__box" key={index}>
            <div className="other-items__box-left">
              <div className="other-items__image">
                {careItem && careItem.product && careItem.product.variants && careItem.product.variants[0].image ? (
                  <Image src={careItem.product.variants[0].image} options={{ w: '130px', h: '130px' }} />
                ) : (
                  <Placeholder w="130px" h="130px" />
                )}
              </div>
            </div>
            <div className="other-items__box-right">
              <h2 className="other-items__heading2">
                {homeCareCategory[careItem.type.replace(' ', '').replace('-', '')] || ''}
              </h2>
              <p className="other-items__paragraph">{careItem.product.name}</p>
            </div>
          </div>
        );
      }
      return null;
    });
  };

  render() {
    const {
      copy,
      selectedHairCare,
      selectedScalpCare,
      selectedHomeCareHairItems,
      selectedHomeCareScalpItems,
      selectedCareMenu,
      changeCurrentScene,
    } = this.props;
    const { loadingFinish, loadingTreatment } = this.state;
    const sublimicDiagnosisResultsCopy = (copy && copy.sublimicDiagnosisResults) || {};
    return (
      <Background>
        <Container>
          <Title className="underline">
            {(sublimicDiagnosisResultsCopy &&
              sublimicDiagnosisResultsCopy.confirmation &&
              sublimicDiagnosisResultsCopy.confirmation.title) || <Placeholder w="300px" h="30px" />}
          </Title>
          <Hr />
          <Contents>
            <Wrapper>
              <SubTitle>
                <div className="sub-title__box-left">
                  <h1 className="sub-title__heading">
                    {(sublimicDiagnosisResultsCopy &&
                      sublimicDiagnosisResultsCopy.HomeCare &&
                      sublimicDiagnosisResultsCopy.HomeCare.title) || <Placeholder w="50px" h="14px" />}
                  </h1>
                </div>
                <div className="sub-title__box-right">
                  <button
                    className="sub-title__button"
                    type="button"
                    onClick={e => {
                      e.preventDefault();
                      if (changeCurrentScene) changeCurrentScene('care');
                    }}
                  >
                    {(sublimicDiagnosisResultsCopy &&
                      sublimicDiagnosisResultsCopy.HomeCare &&
                      sublimicDiagnosisResultsCopy.HomeCare.changeCtaLabel) || <Placeholder w="50px" h="14px" />}
                  </button>
                </div>
              </SubTitle>
              <CareMenu>
                {(selectedCareMenu === CATEGORY_HAIRCARE || selectedCareMenu === CATEGORY_HAIR_SCALP_CARE) &&
                  this.renderCareMenu(selectedHairCare, CATEGORY_HAIRCARE)}
                {(selectedCareMenu === CATEGORY_SCALPCARE || selectedCareMenu === CATEGORY_HAIR_SCALP_CARE) &&
                  this.renderCareMenu(selectedScalpCare, CATEGORY_SCALPCARE)}
              </CareMenu>
            </Wrapper>
          </Contents>
          <Contents>
            <Wrapper>
              <SubTitle>
                <div className="sub-title__box-left">
                  <h1 className="sub-title__heading">
                    {(sublimicDiagnosisResultsCopy &&
                      sublimicDiagnosisResultsCopy.HomeCare &&
                      sublimicDiagnosisResultsCopy.HomeCare.selecthomecare) || <Placeholder w="50px" h="14px" />}
                  </h1>
                </div>
                <div className="sub-title__box-right">
                  <button
                    className="sub-title__button"
                    type="button"
                    onClick={e => {
                      e.preventDefault();
                      if (changeCurrentScene) changeCurrentScene('home-care');
                    }}
                  >
                    {(sublimicDiagnosisResultsCopy &&
                      sublimicDiagnosisResultsCopy.HomeCare &&
                      sublimicDiagnosisResultsCopy.HomeCare.changeCtaLabel) || <Placeholder w="50px" h="14px" />}
                  </button>
                </div>
              </SubTitle>
              <HomeCare>
                <Items>
                  {selectedCareMenu === CATEGORY_HAIRCARE && this.renderHomeCareItem(selectedHomeCareHairItems)}
                  {selectedCareMenu === CATEGORY_SCALPCARE && this.renderHomeCareItem(selectedHomeCareScalpItems)}
                  {selectedCareMenu === CATEGORY_HAIR_SCALP_CARE &&
                    this.renderHomeCareItem(selectedHomeCareHairItems.concat(selectedHomeCareScalpItems))}
                </Items>
              </HomeCare>
              <OtherItems>
                <h1 className="other-items__heading">
                  {(sublimicDiagnosisResultsCopy &&
                    sublimicDiagnosisResultsCopy.HomeCare &&
                    sublimicDiagnosisResultsCopy.HomeCare.otherItemText) || <Placeholder w="100px" h="20px" />}
                </h1>
                {selectedCareMenu === CATEGORY_HAIRCARE && this.renderWonderShield(selectedHomeCareHairItems)}
                {selectedCareMenu === CATEGORY_SCALPCARE && this.renderWonderShield(selectedHomeCareScalpItems)}
                {selectedCareMenu === CATEGORY_HAIR_SCALP_CARE && this.renderWonderShield(selectedHomeCareHairItems)}
                {/* {selectedCareMenu === CATEGORY_HAIRCARE && (
                  <div className="other-items__box2">
                    <Items>{this.renderHomeCareItem(selectedHomeCareScalpItems, CATEGORY_SCALPCARE)}</Items>
                  </div>
                )}
                {selectedCareMenu === CATEGORY_SCALPCARE && (
                  <div className="other-items__box2">
                    <Items>{this.renderHomeCareItem(selectedHomeCareHairItems, CATEGORY_HAIRCARE)}</Items>
                  </div>
                )}
                */}
                {selectedCareMenu === CATEGORY_HAIRCARE && (
                  <div className="other-items__box2">
                    <Items>
                      {this.renderHomeCareItem(selectedHomeCareScalpItems.filter(item => item.type !== 'Shampoo'))}
                    </Items>
                  </div>
                )}
                {selectedCareMenu === CATEGORY_SCALPCARE && (
                  <div className="other-items__box2">
                    <Items>
                      {this.renderHomeCareItem(selectedHomeCareHairItems.filter(item => item.type !== 'Shampoo'))}
                    </Items>
                  </div>
                )}
              </OtherItems>
            </Wrapper>
          </Contents>
          <Navi>
            <button className="navi__button" type="button" onClick={this.handleOpenModal}>
              {(sublimicDiagnosisResultsCopy &&
                sublimicDiagnosisResultsCopy.confirmation &&
                sublimicDiagnosisResultsCopy.confirmation.comfirmCtaLabel) || <Placeholder w="100px" h="16px" />}
            </button>
          </Navi>
          <Modal
            isOpen={this.state.finishModal.isOpen}
            hasHeader
            onClose={this.handleCloseModal}
            contentBodyItems={[
              {
                type: 'BUTTON_BUTTON',
                item: {
                  copy,
                  saveAndFinish: this.saveAndFinish,
                  saveAndTreatment: this.saveAndTreatment,
                  loadingFinish,
                  loadingTreatment,
                },
              },
            ]}
            styleType="sublimicDiagnosisConfirmType"
          />
        </Container>
      </Background>
    );
  }
}

ConfirmPage.defaultProps = {
  copy: {},
  homeCareCategory: {},
  authSalonSettingData: {},
  selectedScalpCare: {},
  selectedHairCare: {},
  selectedHomeCareHairItems: [],
  selectedHomeCareScalpItems: [],
  selectedCareMenu: CATEGORY_HAIRCARE,
  recommendedHomeCareHairItems: [],
  recommendedHomeCareScalpItems: [],
  homeCareHairItems: [],
  homeCareScalpItems: [],
  changeCurrentScene: null,
  // handleOpenModal: null,
  // handleCloseModal: null,
};
ConfirmPage.propTypes = {
  copy: PropTypes.shape({}),
  locale: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  authSalonSettingData: PropTypes.shape({}),
  homeCareCategory: PropTypes.shape({}),
  selectedScalpCare: PropTypes.shape({}),
  selectedHairCare: PropTypes.shape({}),
  // eslint-disable-next-line react/forbid-prop-types
  selectedHomeCareHairItems: PropTypes.array,
  // eslint-disable-next-line react/forbid-prop-types
  selectedHomeCareScalpItems: PropTypes.array,
  // eslint-disable-next-line react/forbid-prop-types
  selectedCareMenu: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  recommendedHomeCareHairItems: PropTypes.array,
  // eslint-disable-next-line react/forbid-prop-types
  recommendedHomeCareScalpItems: PropTypes.array,
  // eslint-disable-next-line react/forbid-prop-types
  homeCareHairItems: PropTypes.array,
  // eslint-disable-next-line react/forbid-prop-types
  homeCareScalpItems: PropTypes.array,
  changeCurrentScene: PropTypes.func,
  // handleOpenModal: PropTypes.func,
  // handleCloseModal: PropTypes.func,
  updateDiagnosisResult: PropTypes.func.isRequired,
};
const mapState = state => ({
  copy: state.salonConsultaionSiteOptions.siteCopy,
  locale: state.locale,
  sublimicDiagnosis: state.sublimicDiagnosis,
  sublimicDiagnosisResults: state.diagnosisResult,
  customerProfile: state.customerProfile,
  authSalonSettingData: state.authSalonSettings,
  homeCareCategory: state.salonConsultaionSiteOptions.siteCopy.sublimicDiagnosisResults.HomeCare,
  selectedScalpCare: state.diagnosisResult.selectedScalpCare,
  selectedHairCare: state.diagnosisResult.selectedHairCare,
  selectedHomeCareHairItems: state.diagnosisResult.selectedHomeCareHairItems,
  selectedHomeCareScalpItems: state.diagnosisResult.selectedHomeCareScalpItems,
  selectedCareMenu: state.diagnosisResult.selectedCareMenu,
  recommendedHomeCareHairItems: state.diagnosisResult.recommendedHomeCareHairItems,
  recommendedHomeCareScalpItems: state.diagnosisResult.recommendedHomeCareScalpItems,
});
const mapDispatch = dispatch => ({
  updateDiagnosisResult: data => dispatch(updateDiagnosisResult(data)),
});

export default connect(mapState, mapDispatch)(ConfirmPage);



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisResultPage/ConfirmPage/ConfirmPage.js